import React from 'react';

const SellerIcon = props => (
	<svg width={35} height={33} {...props}>
		<g fill="none" fillRule="evenodd">
			<circle cx={16} cy={16} r={16} fill="#9B9B9B" />
			<path
				d="M21.455 16.455c-.644 0-1.262-.151-1.819-.436a3.971 3.971 0 0 1-1.818.436c-.643 0-1.262-.151-1.818-.436a3.971 3.971 0 0 1-1.818.436 3.98 3.98 0 0 1-1.818-.435 3.98 3.98 0 0 1-1.819.435 4.07 4.07 0 0 1-1.09-.15v7.422c0 .402.325.728.727.728h4.363v-3.637h2.91v3.637h4.363a.728.728 0 0 0 .727-.728v-7.422a4.07 4.07 0 0 1-1.09.15zm2.423-4.767l-2.91-4.364A.727.727 0 0 0 20.365 7h-8.728a.727.727 0 0 0-.605.324l-2.909 4.364a.729.729 0 0 0-.122.403C8 13.804 9.047 15 10.545 15c.712 0 1.356-.293 1.819-.766a2.536 2.536 0 0 0 1.818.766c.712 0 1.355-.293 1.818-.766a2.536 2.536 0 0 0 1.818.766c.712 0 1.356-.293 1.818-.766a2.536 2.536 0 0 0 1.819.766C22.953 15 24 13.804 24 12.09a.729.729 0 0 0-.122-.402z"
				fill="#FFF"
				fillRule="nonzero"
			/>
			<g transform="translate(20 18)">
				<circle cx={7} cy={7} r={7} fill="#38BFC3" stroke="#FFF" />
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M3 6.8l.8-.8 2 1.2L10.2 4l.8.8L5.8 10z"
				/>
			</g>
		</g>
	</svg>
);

export default SellerIcon;
